import type { PropsWithChildren } from 'react'

import { useAuthCheck } from '../logic/use-auth-check'

export const AuthInitializer = ({ children }: PropsWithChildren) => {
  const { isChecking } = useAuthCheck()

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto" />
          <p className="mt-4 text-gray-600">Initializing application...</p>
        </div>
      </div>
    )
  }

  return children
}
